/* eslint-disable */
export default {
  log: 'Loki',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
